import { Injectable, inject } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FilterSelectItem } from '../../../components/checkbox-facette/checkbox-liste/filterSelectItem';
import { AggregationKey } from '../../../model/aggregations';
import { Anbieter } from '../../../model/anbieter';
import { FacettenService } from '../facetten.service';
import { AnbieterUrlService } from './anbieterurl.service';

/**
 * Stellt Observables bereit, um die Anbieter-Facette zu befüllen.
 * Dabei werden die aktuelle Auswahl der Anbieter integriert.
 */
@Injectable({
  providedIn: 'root'
})
export class AnbieterService extends FacettenService {
  constructor() {
    const facettenUrlService = inject(AnbieterUrlService);

    super(facettenUrlService, AggregationKey.Anbieter, []);
  }

  public anbieter$: Observable<Anbieter[]> = combineLatest([
    this.filterAggregationsService.anbieterFilterAggregations$,
    this.facettenUrlService.selectedOptionIds$
  ]).pipe(
    map(([{ ANBIETER }, selektierteAnbieter]) =>
      Object.entries(ANBIETER).map(([id, anbieter]) => ({
        id,
        name: anbieter.name,
        ausgewaehlt: selektierteAnbieter.includes(id),
        anzahlAngebote: anbieter.anzahlErgebnisse
      }))
    )
  );

  public override getSelectItems$(): Observable<FilterSelectItem[]> {
    return combineLatest([
      this.filterAggregationsService.anbieterFilterAggregations$,
      this.selectedIds$
    ]).pipe(
      map(([{ ANBIETER }, selektierteAnbieter]) =>
        Object.entries(ANBIETER).map(([id, anbieter]) => ({
          key: id,
          ariaLabel: anbieter.name,
          treffer: anbieter.anzahlErgebnisse,
          label: anbieter.name,
          selected: selektierteAnbieter.includes(id),
          active: true
        }))
      )
    );
  }

  private readonly numberSelected: Observable<number> =
    this.facettenUrlService.selectedOptionIds$.pipe(map((anbieterIds) => anbieterIds.length));

  private readonly hasItems$: Observable<boolean> = this.anbieter$.pipe(
    map((anbieter) => anbieter?.length > 0)
  );

  // Setzt den expansion state der Facette
  public override setExpanded(expanded: boolean) {
    this._expanded$.next(expanded);
  }

  /**
   * Anzahl der ausgewählten, aktiven Optionen
   */
  public override getNumberSelected$(): Observable<number> {
    return this.numberSelected;
  }

  /**
   * Wahr gdw. aktiven Optionen vorhanden sind
   */
  public override getHasItems$(): Observable<boolean> {
    return this.hasItems$;
  }

  // Aktualisiert den ausgewählten Filter
  public override updateSelectedIds(selectedIds: string[]): void {
    this.facettenUrlService.updateSelection(selectedIds);
  }
}
